import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { HospitalsResponse } from './types'
import { useQuery } from '@tanstack/react-query'

const fetchHospitals = async () => {
  const response = await httpClientPrivate.get<HospitalsResponse>(
    `${config.restUrl}/v1/backoffice/e-claim/hospitals`,
  )

  return response.data
}

export const useHospitals = () => {
  const queryKey = ['useHospitals']
  const queryFn = async () => fetchHospitals()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchHospitals }
